import { render, staticRenderFns } from "./MessageRowResourcePlus.vue?vue&type=template&id=8c6631de&scoped=true&"
import script from "./MessageRowResourcePlus.vue?vue&type=script&lang=js&"
export * from "./MessageRowResourcePlus.vue?vue&type=script&lang=js&"
import style0 from "./MessageRowResourcePlus.vue?vue&type=style&index=0&id=8c6631de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6631de",
  null
  
)

export default component.exports